import { formatISO, parseISO } from "date-fns";
import { useActions } from "../../../../../hooks/useActions";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import CustomDatePicker from "../../../../CustomDatePicker";
import { FilterIdsEnum } from "../../../../../store/reducers/_maps/main/mapFilters/types";
import FilterButtonWithModal from "../../../../../share/filters/FilterButtonWithModal";

const RegistrationDateFilter = () => {
  const filterId: FilterIdsEnum = "cybersecurityRegistrationDate";
  const { registration_date__gte, registration_date__lte } = useTypedSelector(
    (state) => state.cybersecurityMapFilters
  );
  const {
    setCybersecurityRegistrationStartDate,
    setCybersecurityRegistrationEndDate,
    cleanCybersecurityRegistrationDate,
    applyFilter,
  } = useActions();

  const handleChangeStartDate = (date: Date | null) => {
    if (!date) {
      cleanCybersecurityRegistrationDate([]);
      return;
    }
    setCybersecurityRegistrationStartDate(
      formatISO(date, { representation: "date" })
    );
    applyFilter();
  };

  const handleChangeEndDate = (date: Date | null) => {
    if (!date) {
      cleanCybersecurityRegistrationDate([]);
      return;
    }
    setCybersecurityRegistrationEndDate(
      formatISO(date, { representation: "date" })
    );
    applyFilter();
  };

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.cybersecurity.registrationDateFilter",
  });
  const title = t("title");
  const pinText = registration_date__gte || registration_date__lte ? 1 : "";

  return (
    <FilterButtonWithModal
      title={title}
      filterId={filterId}
      pinText={pinText}
      onClear={() => cleanCybersecurityRegistrationDate([])}
      isScroll={false}
    >
      <CustomDatePicker
        startDate={
          registration_date__gte ? parseISO(registration_date__gte) : null
        }
        endDate={
          registration_date__lte ? parseISO(registration_date__lte) : null
        }
        setStartDate={handleChangeStartDate}
        setEndDate={handleChangeEndDate}
      />
    </FilterButtonWithModal>
  );
};

export default RegistrationDateFilter;
